// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {AnchorHTMLAttributes, ButtonHTMLAttributes} from 'react';
import {Link, LinkProps} from 'react-router-dom';
import cn from 'classnames';
import styles from './button.module.less';

export type t_native_button_props = ButtonHTMLAttributes<HTMLButtonElement>;
export type t_native_anchor_props = AnchorHTMLAttributes<HTMLAnchorElement>;

interface i_basic_button_common_props {
    caption: React.ReactNode;
    cls?: string;
    icon_left?: JSX.Element;
    icon_right?: JSX.Element;
}

interface i_button_variant {
    tag: 'button';
    button_props: t_native_button_props;
}

interface i_anchor_variant {
    tag: 'a';
    button_props: t_native_anchor_props;
}

interface i_link_variant {
    tag: 'link';
    button_props: LinkProps;
}

export type i_basic_button_variants = i_button_variant | i_anchor_variant
    | i_link_variant;

export type i_basic_button_props = i_basic_button_variants
    & i_basic_button_common_props;

export const Basic_button = (props: i_basic_button_props)=>{
    const {tag, caption, cls, button_props, icon_left, icon_right} = props;
    const Tag = (tag === 'link' ? Link : tag) as React.ElementType;
    const btn_cls = cn(styles.basic_button, cls);
    return <Tag {...button_props} className={btn_cls}>
        {icon_left}
        <span data-elem="caption">{caption}</span>
        {icon_right}
    </Tag>;
};
